module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.entity.sections) ? _c('div', [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-main-about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-main-about"
    },
    model: {
      value: (_vm.entity.boxes.box1.text),
      callback: function($$v) {
        _vm.$set(_vm.entity.boxes.box1, "text", $$v)
      },
      expression: "entity.boxes.box1.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box1-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box1.show_images_slider),
      expression: "entity.boxes.box1.show_images_slider"
    }],
    attrs: {
      "id": "box1-include-slider",
      "type": "checkbox",
      "disabled": _vm.isImagesSliderSelected && !_vm.entity.boxes.box1.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box1.show_images_slider) ? _vm._i(_vm.entity.boxes.box1.show_images_slider, null) > -1 : (_vm.entity.boxes.box1.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box1.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box1, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isImagesSliderSelected && !_vm.entity.boxes.box1.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one image slider\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.entity.boxes.box1.show_images_slider),
      expression: "entity.boxes.box1.show_images_slider"
    }],
    staticClass: "col-md-12 mt-2"
  }, [(_vm.dropzoneOptions) ? _c('dropzone', {
    ref: "dropzone",
    attrs: {
      "id": "files-uploader",
      "options": _vm.dropzoneOptions,
      "destroy-dropzone": false
    },
    on: {
      "vdropzone-file-added": _vm.fileUploadedSuccess,
      "vdropzone-removed-file": _vm.fileRemoved
    }
  }) : _c('div', [_vm._v("Dropzone can't work without upload url.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.dropzone.dropzone.element.click()
      }
    }
  }, [_vm._v("\n                          Select Images\n                        ")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "branch-main-info"
    }
  }, [_vm._v("Info")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('ckeditor', {
    attrs: {
      "id": "branch-main-info"
    },
    model: {
      value: (_vm.entity.boxes.box2.text),
      callback: function($$v) {
        _vm.$set(_vm.entity.boxes.box2, "text", $$v)
      },
      expression: "entity.boxes.box2.text"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-show-news-notes"
    }
  }, [_vm._v("Show News Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_news_notes),
      expression: "entity.boxes.box3.show_news_notes"
    }],
    attrs: {
      "id": "box3-show-news-notes",
      "type": "checkbox",
      "disabled": _vm.entity.boxes.box3.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_news_notes) ? _vm._i(_vm.entity.boxes.box3.show_news_notes, null) > -1 : (_vm.entity.boxes.box3.show_news_notes)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_news_notes,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_news_notes", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-show-announcements"
    }
  }, [_vm._v("Show Announcements")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_announcements),
      expression: "entity.boxes.box3.show_announcements"
    }],
    attrs: {
      "id": "box3-show-announcements",
      "type": "checkbox",
      "disabled": (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box3.show_announcements) ||
        _vm.entity.boxes.box3.show_images_slider
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_announcements) ? _vm._i(_vm.entity.boxes.box3.show_announcements, null) > -1 : (_vm.entity.boxes.box3.show_announcements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_announcements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_announcements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_announcements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_announcements", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box3.show_announcements) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one announcements list\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box3-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box3.show_images_slider),
      expression: "entity.boxes.box3.show_images_slider"
    }],
    attrs: {
      "id": "box3-include-slider",
      "type": "checkbox",
      "disabled": (_vm.isImagesSliderSelected && !_vm.entity.boxes.box3.show_images_slider) ||
        _vm.entity.boxes.box3.show_announcements || _vm.entity.boxes.box3.show_news_notes
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box3.show_images_slider) ? _vm._i(_vm.entity.boxes.box3.show_images_slider, null) > -1 : (_vm.entity.boxes.box3.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box3.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box3, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.isImagesSliderSelected && !_vm.entity.boxes.box3.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                          Please use one image slider\n                        ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-body form-horizontal"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noteShown),
      expression: "noteShown"
    }],
    staticClass: "mb-5"
  }, [_c('div', {
    staticClass: "saving-alerts"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.noteShown = !_vm.noteShown
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _vm._v(" "), _c('strong', [_vm._v("Note:")]), _vm._v(" "), _c('p', [_vm._v("Please use a valid link")]), _vm._v(" "), _c('strong', [_vm._v("Example:")]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "facebookLink"
    }
  }, [_vm._v("Facebook")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.facebook),
      expression: "entity.boxes.box4.socials.facebook"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "facebookLink",
      "type": "text",
      "placeholder": "Enter Facebook link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.facebook)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "facebook", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "instaLink"
    }
  }, [_vm._v("Instagram")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.instagram),
      expression: "entity.boxes.box4.socials.instagram"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "instaLink",
      "type": "text",
      "placeholder": "Enter Instagram link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.instagram)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "instagram", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "twitterLink"
    }
  }, [_vm._v("Twitter")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.twitter),
      expression: "entity.boxes.box4.socials.twitter"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "twitterLink",
      "type": "text",
      "placeholder": "Enter Twitter link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.twitter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "twitter", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "pinterestLink"
    }
  }, [_vm._v("Pinterest")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.pinterest),
      expression: "entity.boxes.box4.socials.pinterest"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "pinterestLink",
      "type": "text",
      "placeholder": "Enter Pinterest link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.pinterest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "pinterest", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink1"
    }
  }, [_vm._v("Youtube Video or Playlist 1")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube1),
      expression: "entity.boxes.box4.socials.youtube1"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink1",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink2"
    }
  }, [_vm._v("Youtube Video or Playlist 2")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube2),
      expression: "entity.boxes.box4.socials.youtube2"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink2",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube2", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "youtubeLink3"
    }
  }, [_vm._v("Youtube Video or Playlist 3")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.socials.youtube3),
      expression: "entity.boxes.box4.socials.youtube3"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "youtubeLink3",
      "type": "text",
      "placeholder": "Enter Youtube Playlist link",
      "disabled": _vm.entity.boxes.box4.show_announcements || _vm.entity.boxes.box4.show_images_slider
    },
    domProps: {
      "value": (_vm.entity.boxes.box4.socials.youtube3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entity.boxes.box4.socials, "youtube3", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box4-show-announcements"
    }
  }, [_vm._v("Show Announcements")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.show_announcements),
      expression: "entity.boxes.box4.show_announcements"
    }],
    attrs: {
      "id": "box4-show-announcements",
      "type": "checkbox",
      "disabled": (_vm.isAnnouncementsSelected && !_vm.entity.boxes.box4.show_announcements) ||
        _vm.entity.boxes.box4.show_images_slider ||
        _vm.socialsExist
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box4.show_announcements) ? _vm._i(_vm.entity.boxes.box4.show_announcements, null) > -1 : (_vm.entity.boxes.box4.show_announcements)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box4.show_announcements,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box4, "show_announcements", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box4, "show_announcements", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box4, "show_announcements", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.entity.boxes.box4.show_announcements) ? _c('div', {
    staticClass: "col-md-12 mt-2"
  }) : _vm._e(), _vm._v(" "), (_vm.socialsExist) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Use either socials or announcements\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.isAnnouncementsSelected &&
    !_vm.entity.boxes.box4.show_announcements) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Please use one announcements list\n                                ")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-md-2",
    attrs: {
      "for": "box4-include-slider"
    }
  }, [_vm._v("Show Photos Slider")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "branch_tooltip"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entity.boxes.box4.show_images_slider),
      expression: "entity.boxes.box4.show_images_slider"
    }],
    attrs: {
      "id": "box4-include-slider",
      "type": "checkbox",
      "disabled": (_vm.isImagesSliderSelected && !_vm.entity.boxes.box4.show_images_slider) ||
        _vm.entity.boxes.box4.show_announcements ||
        _vm.socialsExist
    },
    domProps: {
      "checked": Array.isArray(_vm.entity.boxes.box4.show_images_slider) ? _vm._i(_vm.entity.boxes.box4.show_images_slider, null) > -1 : (_vm.entity.boxes.box4.show_images_slider)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.entity.boxes.box4.show_images_slider,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.entity.boxes.box4, "show_images_slider", $$c)
        }
      }
    }
  }), _vm._v(" "), (_vm.socialsExist) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Use either socials or image slider\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.isImagesSliderSelected &&
    !_vm.entity.boxes.box4.show_images_slider) ? _c('span', {
    staticClass: "branch_tooltiptext"
  }, [_vm._v("\n                                  Please use one image slider\n                                ")]) : _vm._e()])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save\n                  "), _c('span', {
    staticClass: "btn-loader",
    staticStyle: {
      "display": "none"
    }
  })])])])])])])])]) : _c('div', [_vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 1")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 2")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 3")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('strong', [_vm._v("Box 4")]), _vm._v(" "), _c('div', {
    staticClass: "card-collapse"
  }, [_vm._v("Collapse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                              For url\n                              "), _c('strong', [_vm._v(" https://www.facebook.com/ellenwhiteestate ")]), _vm._v("\n                              a valid link is "), _c('strong', [_vm._v("ellenwhiteestate")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('strong', [_vm._v("There are no sections for this branch yet.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121a9d57","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/branchOffices/sections/MainPage.vue
// module id = 822
// module chunks = 0